const Colors = () => {
  return {
    WHITE: new Color("white"),
    WHITE_HEX: new Color('#FFFFFF'),
    rgb: function(r, g, b) {
      return new Color('#' + (r < 16 ? '0' + r.toString(16) : r.toString(16)) + (g < 16 ? '0' + g.toString(16) : g.toString(16)) + (b < 16 ? '0' + b.toString(16) : b.toString(16)));
    },
    rgba: function(r, g, b, a) {
      return new Color('#' + (r < 16 ? '0' + r.toString(16) : r.toString(16)) + (g < 16 ? '0' + g.toString(16) : g.toString(16)) + (b < 16 ? '0' + b.toString(16) : b.toString(16)) + (a * 255).toString(16).substring(0, 2));
    },
    from: function(value) {
      return new Color(value);
    }
  }
}

class Color {

  constructor(value) {
    this.value = value;
  }

  toRGBA(alpha) {
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.value)){
        c= this.value.substring(1).split('');
        if(c.length === 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + alpha + ')';
    }
    throw new Error(this.value + ': Bad Hex');
  }

}

export default Colors();



// WEBPACK FOOTER //
// ./src/utils/Colors.js